import React from "react";
import THFila from "../../Componentes/THFila";
import { formatoFecha } from "../../Formatos";
interface Props {
    fecha: string
}
export default function FechaTh({ fecha }: Props) {
    return <THFila width="90px" align='center'>{formatoFecha(fecha)}</THFila>
}